export const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export function trackPageView() {
    if (!GA4_ID || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
    });
}
